import {BpsUser, bpsUserDecoder} from './BpsUser'
import {Decoder, field, nullable, object} from 'json-bouncer'
import {InquiryComment, inquiryCommentDecoder} from './InquiryComment'
import {Cis2User, cis2UserDecoder} from './Cis2User'

export interface InquiryCommentWithUsers {
    readonly inquiryComment: InquiryComment
    readonly bpsUser: BpsUser | null
    readonly cis2User: Cis2User | null
}

export function inquiryCommentWithUsersDecoder(): Decoder<InquiryCommentWithUsers> {
    return object({
        inquiryComment: field('inquiryComment', inquiryCommentDecoder()),
        bpsUser: field('bpsUser', nullable(bpsUserDecoder())),
        cis2User: field('cis2User', nullable(cis2UserDecoder())),
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/InquiryCommentWithUsers.ts